import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { locale as navigationEnglish } from 'app/navigation/i18n/en';
import { locale as navigationTurkish } from 'app/navigation/i18n/tr';
import { AppInitializationService } from 'app/app-initialization.service';


@Component({
    selector: 'vertical-layout-1',
    templateUrl: './layout-1.component.html',
    styleUrls: ['./layout-1.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [FuseSplashScreenService]
})
export class VerticalLayout1Component implements OnInit, OnDestroy {
    fuseConfig: any;
    navigation: Array<any> = [];
    userName: any;
    admin: number;
    companyId: number;
    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        @Inject(DOCUMENT) private document: any,
        private _fuseNavigationService: FuseNavigationService,
        private appConfigService:AppInitializationService,
        private _fuseSidebarService: FuseSidebarService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _platform: Platform,
    ) {
        // Set the defaults

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit() {
        try {
            this.userName = localStorage.getItem("Username");
            this.admin = parseInt(localStorage.getItem("RoleID"));
            this.companyId = parseInt(localStorage.getItem("CompanyID"));
        } catch (error) {
            console.warn(error);

        }

        //Get Db Menu
        let bymenus = await this._fuseNavigationService.getByNavigationApi(this.admin,this.companyId);
        var isShift = this.appConfigService.apiConfig["isShift"]

        if(!isShift){
            var index = bymenus.findIndex(x=>x.id==21)
            if(index!=-1){
                bymenus.splice(index,1);
            }
        }

        let parents = bymenus.filter(x => x.parentId == null);
        this.navigation = parents;
        for (let index = 0; index < bymenus.length; index++) {
            const element = bymenus[index];
            let subMenus = bymenus.filter(x => x.parentId == element.id)
            element.children = subMenus;
        }
        // Set the private defaults
        this._unsubscribeAll = new Subject();

        // Register the navigation to the service
        this._fuseNavigationService.register('main', this.navigation);

        // Set the main navigation as our current navigation
        this._fuseNavigationService.setCurrentNavigation('main');

        // Add languages
//        this._translateService.addLangs(['en', 'tr']);

        // Set the default language
//        this._translateService.setDefaultLang('tr');

        // Set the navigation translations
        this._fuseTranslationLoaderService.loadTranslations(navigationEnglish, navigationTurkish);

        // Use a language
//        this._translateService.use('tr');
      
        

        // Add is-mobile class to the body if the platform is mobile
        if (this._platform.ANDROID || this._platform.IOS) {
            this.document.body.classList.add('is-mobile');
        }

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.fuseConfig = config;
                // Color theme - Use normal for loop for IE11 compatibility
                for (let i = 0; i < this.document.body.classList.length; i++) {
                    const className = this.document.body.classList[i];

                    if (className.startsWith('theme-')) {
                        this.document.body.classList.remove(className);
                    }
                }

                this.document.body.classList.add(this.fuseConfig.colorTheme);
            });



    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }
}






